import React from 'react';
import { Button } from '../ui';

/** @deprecated Use `import { Button } from '../ui'` — kept for gradual migration. */
const BrandButton = React.forwardRef(function BrandButton(
  { tone = 'primary', primaryHover, sx, variant, ...props },
  ref,
) {
  const uiVariant =
    tone === 'accent' ? 'secondary' : variant === 'outlined' ? 'outline' : 'default';

  return <Button ref={ref} variant={uiVariant} sx={sx} {...props} />;
});

export default BrandButton;
